import { ConsoleSqlOutlined } from "@ant-design/icons";
import { axiosDelete, axiosGet, axiosPost, axiosPut } from "./ajaxServices";
import { urlCreateSpoilage, urlDeleteSpoilage, urlGetSpoilageList } from "./CONSTANTS";


export function apiCreateSpoilage(data) {
  const url = urlCreateSpoilage;
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  var formData = new FormData();
  formData.append("author_name", data.author_name);
  formData.append("reason", data.reason);
  formData.append("totalBudget", data.totalBudget);
  formData.append("cartList", JSON.stringify(data.cartList));
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
    .then(function (response) {
      resolve(response);
    })
    .catch((err) => {
      reject(err);
    });
  });
}

export const apiGetSpoilageList = () => {
  const url = urlGetSpoilageList;
  return new Promise((resolve, reject) => {
    axiosGet(url)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export function apiDeleteSpoilage(id) {
  const url = urlDeleteSpoilage;
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };
  var formData = new FormData();
  formData.append("id", id);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
    .then(function (response) {
      resolve(response);
    })
    .catch((err) => {
      reject(err);
    });
  });
}